import {Component, Input, OnInit} from '@angular/core';
import {UserModel} from '../../../../models/user.model';

@Component({
  selector: 'app-user-information-summary-part',
  templateUrl: './user-information-summary-part.component.html',
  styleUrls: ['./user-information-summary-part.component.scss']
})
export class UserInformationSummaryPartComponent implements OnInit {

  @Input() aplicant: UserModel=new UserModel();
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/components/publication-registration/base-summary-form-part/user-information-summary-part/user-information-summary-part.component.ts